import request from '@/utils/request'

/* 二十大学习视频 */
export function getPeopleCongress(params) {
  return request({
    url: '/api/Index/HostIndex',
    method: 'get',
    params
  })
}
/* 二十大学习动态 */
export function getDynamic(params) {
  return request({
    url: '/api/Index/StudyNews',
    method: 'get',
    params
  })
}
export function recordsVideoClick(params) {
  return request({
    url: '/api/Index/HostVideo',
    method: 'get',
    params
  })
}
/* /api/Index/HostVideo */

/* 图说洪雅变化 */
export function getAdmini() {
  return request({
    url: '/api/Index/QueryByTown',
    method: 'get'
  })
}
export function getAtlasIndex(params) {
  return request({
    url: '/api/Index/HomeIndex',
    method: 'get',
    params
  })
}
export function getAtlasDetail(params) {
  return request({
    url: '/api/Index/QueryByCid',
    method: 'get',
    params
  })
}

/* 成果汇编 */
/* get subpage data */
export function getBook(params) {
  return request({
    url: '/api/Index/QueryBook',
    method: 'get',
    params
  })
}

/* 智慧党建 */
export function getPartyBuildingIndex() {
  return request({
    url: '/api/Index/PartyIndex',
    method: 'get'
  })
}

/* 详情: 洪雅党建 */
export function getHyPbDetail(params) {
  return request({
    url: '/api/Index/PartyList',
    method: 'get',
    params
  })
}
/* 详情: 洪雅党建、洪雅党史、先进事迹、乡村振兴 */
export function getPbDetail(params) {
  return request({
    url: '/api/Index/NewList',
    method: 'get',
    params
  })
}
/* 详情: 农民工服务（活动开展、服务保障、风采展示） */
export function getMigrantService(params) {
  return request({
    url: '/api/Index/MigrantService',
    method: 'get',
    params
  })
}
/* 详情: 青年党支部、农民工服务（维权帮助） 下拉 */
export function getPartyBranchDrop(params) {
  return request({
    url: '/api/Index/QueryByParty',
    method: 'get',
    params
  })
}
/* 详情: 青年党支部、农民工服务（维权帮助）列表 */
export function getPartyBranch(params) {
  return request({
    url: '/api/Index/Party',
    method: 'get',
    params
  })
}

/* 直播地址 */
export function getLivingUrl() {
  return request({
    url: '/api/Index/Play',
    method: 'get'
  })
}

export function getLivingTime() {
  return request({
    url: '/api/Index/PlayTime',
    method: 'get'
  })
}

// 2024百部课件下基层学习视频
export function getCoursewareBaseApi(params) {
  return request({
    url: '/api/Index/QueryVideo',
    method: 'get',
    params
  })
}
// 获取站点的直播观看时间
export function getLivingTimeApi(params) {
  return request({
    url: '/api/Live/UpdLiveTime',
    method: 'get',
    params
  })
}
